export function initGleam() {
    const isHome = document.getElementById('is-home');
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                const currentNode = mutation.addedNodes[0];
                if (currentNode.nodeName === 'A' && currentNode.id === 'c9-button') {
                    callback();
                }
            }
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    function callback() {
        if (isHome) {
            const btn = document.getElementById('backToTop');
            btn.style.bottom = '60px';
        }
        else {
            document.body.removeChild(document.getElementById('c9-button'));
        }
        observer.disconnect();
    }
}
